import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mapLoginErrorToMessage, useAuth } from '@ibk/shared-auth';
import { clearPendingDomains, clearPermissioningCache, clearUser, PersonDocumentType, useAppDispatch, useLazyHasAccessQuery, } from '@ibk/shared-config';
import { useTranslation } from '@ibk/shared-translation';
import { LoginErrorsType } from '@ibk/shared-types';
import { useGrid, useTheme } from '@ibk/shared-ui';
export function useLoginAccountant() {
    const { login, loading, error, isLoggedIn, isAuthenticated } = useAuth();
    const [hasAccess] = useLazyHasAccessQuery();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [cpf, setCpf] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [cpfTouched, setCpfTouched] = useState(false);
    const [showInlineError, setShowInlineError] = useState(true);
    const [localAccountantError, setLocalAccountantError] = useState('');
    const [accountantErrorMessage, setAccountantErrorMessage] = useState('');
    const [isMaintenanceOpen, setIsMaintenanceOpen] = useState(false);
    const { t } = useTranslation();
    const theme = useTheme();
    const { deviceType, gridColumns, gridGutter } = useGrid();
    useEffect(() => {
        if (error === LoginErrorsType.MAINTENANCE) {
            setAccountantErrorMessage('');
            setIsMaintenanceOpen(true);
        }
        else if (error) {
            setAccountantErrorMessage(mapLoginErrorToMessage(error, t));
        }
        else if (localAccountantError) {
            setAccountantErrorMessage(localAccountantError);
        }
        else {
            setAccountantErrorMessage('');
        }
    }, [error, localAccountantError, t]);
    useEffect(() => {
        if (isLoggedIn && !isAuthenticated) {
            navigate('/two-factor-select', { replace: true });
        }
    }, [isLoggedIn, navigate, isAuthenticated]);
    const handleLogin = async (cpf, password) => {
        setLocalAccountantError('');
        const cleanDocumentNumber = cpf.replace(/\D/g, '');
        try {
            dispatch(clearPermissioningCache());
            dispatch(clearPendingDomains());
            dispatch(clearUser());
            await login(cleanDocumentNumber, password);
            try {
                await hasAccess({ documentNumber: cleanDocumentNumber, documentType: PersonDocumentType.CPF }).unwrap();
            }
            catch (userError) {
            }
        }
        catch (err) {
            if (err instanceof Error) {
                if (err.message === LoginErrorsType.INVALID_CREDENTIALS) {
                    setLocalAccountantError(t('auth.error.invalid-credentials'));
                }
                else {
                    setLocalAccountantError(t('auth.error.generic'));
                }
            }
        }
    };
    return {
        cpf,
        setCpf,
        password,
        setPassword,
        showPassword,
        setShowPassword,
        cpfTouched,
        setCpfTouched,
        showInlineError,
        setShowInlineError,
        accountantErrorMessage,
        isLoading: loading,
        isMaintenanceOpen,
        closeMaintenance: () => setIsMaintenanceOpen(false),
        handleLogin,
        isAuthenticated,
        deviceType,
        gridColumns,
        gridGutter,
        theme,
        navigate,
    };
}
